import React, { useState } from "react";

interface CodeVariant {
  label: string;
  value: string;
}

interface CodeBlockProps {
  title?: string;
  variants: CodeVariant[];
}

export const CodeBlock: React.FC<CodeBlockProps> = ({ title, variants }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [copied, setCopied] = useState(false);

  const activeCode = variants[activeIndex]?.value || "";

  const handleCopy = () => {
    navigator.clipboard.writeText(activeCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="rounded-xl overflow-hidden border border-white/[0.08] bg-white/[0.04] text-sm mt-4">
      
      {/* Header */}
      {(title || variants.length > 1) && (
        <div className="flex items-center justify-between px-4 py-2 bg-[#1a1d27] border-b border-gray-700">
          <span className="text-white/70 text-xs font-mono">
            {title || variants[activeIndex]?.label}
          </span>

          <button
            onClick={handleCopy}
            className="text-xs text-gray-400 hover:text-white transition-colors flex items-center gap-1"
          >
            {copied ? (
              <>
                <svg
                  className="w-3 h-3 text-emerald-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span className="text-emerald-400">Copied!</span>
              </>
            ) : (
              <>
                <svg
                  className="w-3 h-3"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                  />
                </svg>
                Copy
              </>
            )}
          </button>
        </div>
      )}

      {/* Tabs */}
      {variants.length > 1 && (
        <div className="flex gap-2 px-3 py-2 bg-[#151822] border-b border-gray-800">
          {variants.map((variant, index) => (
            <button
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`px-3 py-1 text-xs rounded-md transition-colors ${
                activeIndex === index
                  ? "bg-white text-black"
                  : "text-gray-400 hover:text-white"
              }`}
            >
              {variant.label}
            </button>
          ))}
        </div>
      )}

      {/* Code */}
      <pre className="overflow-x-auto p-4 text-sm text-web-primary">
        <code>{activeCode}</code>
      </pre>
    </div>
  );
};
